

































































import ReviewState from '@/components/ReviewState.vue'
import ReviewDetail from '@/components/ReviewDetail.vue'
import EstablishmentInfo from '@/components/EstablishmentInfo.vue'
import settings from "@/settings.coffee"
import queries from "@/gql/queries.coffee"
import utils from '@/utils.coffee'
import mutations from "@/gql/mutations.coffee"

export default {
    name: "FlowDetail",
    components: {ReviewState, ReviewDetail, EstablishmentInfo}
    props: {
        "uid": {
            "required": false,
            "type": String
        },
        "showPad": true
    }
    "methods":
        "get_middle_pannel_style": ()->
            ret = {}
            if @showPad
                ret = {
                    'width': @middleColWidth+'px' ,
                    'min-width': @middleColWidth+'px'
                }
            return ret
        "delete_state": ()->
            self = this
            mutations.run("review_state_back", [self.review.uid]).then (resp)->
                if not resp.body.data.review_state_back.ok
                    console.error("error", resp.body.data)
                    
        "fetch_data": ()->
            self = this
            if self.review_uid?
                response = await self.$http.post(settings.graphqlApiUrl, {query: queries.gql_query_review_detail(self.review_uid)})
                if response.ok
                    self.review = response.body.data.review
                setTimeout(()->
                    self.setHeight()
                ,1)
        "setHeight": utils.debounce(
            ()->
                if @$refs.reviewDetail?
                    @timelineHeight = (window.innerHeight-@$refs.reviewDetail.$el.clientHeight - 100)+ "px"
                @middleColWidth = window.innerWidth * 1.1 / 3
                return
            , 500)
    "watch":
        "review_uid": (new_value, old_value)->
            self = this
            if new_value?
                if new_value != old_value
                    self.fetch_data()
    "computed":
        "review_uid": ()->
            return this.$store.state.selected_review_uid
        "timelineStyle":()->
            {height:@timelineHeight}
        "logo": () -> 
            self = this
            return settings.backendMediaUrl + self.review.establishment.logo
    "data": ()->
        return {
            review: null
            timelineHeight: "500px"
            middleColWidth: window.innerWidth * 1.1 / 3
        }
    "mounted": ()->
        self = this
        self.fetch_data()
        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            if event.obj?
                
                if event.obj.review == self.review_uid
                    self.fetch_data()
        )
        self.$djangows['onmodelsignals']({"modelName": "review", "appLabel": "review"}, (event)->
            if event.obj.uid == self.review_uid
                self.fetch_data()
        )
        vm = this
        vm.setHeight()
        window.addEventListener('resize', vm.setHeight)
}
